import React, {useContext} from "react";
import {
  Box,
  Typography,
  Link,
  Grid,
  Container,
  IconButton,
} from "@mui/material";
import {
  Instagram as InstagramIcon,
  FacebookOutlined as FacebookOutlinedIcon,
  X as XIcon,
  LinkedIn as LinkedInIcon,
} from "@mui/icons-material";
import { FunctionContext } from "../context/FunctionProvider";
import { path } from "../constant";
import logo from '../assets/svg/Frame 3465990.svg'


const Footer = () => {
  const { t } = useContext(FunctionContext);
  const quickLinks = [
    { name: t("footerhomebtn"), route: path.landingPage },
    { name: t("footerjobtn"), route: path.searchPagelink },
    { name: t("footeraboutusbtn"), route: path.aboutus },
    { name: t("footercontactusbtn"), route: path.contactus },
  ];
  const websiteInfoLinks = [
    { name: t("footerprivacybtn"), route: path.privacypolicy },
    { name: t("footertermsbtn"), route: path.terms },
    { name: t("footercopyrightsbtn"), route: path.copyright },
  ];
  const socialMediaIcons = [
    // <InstagramIcon />,
    // <FacebookOutlinedIcon />,
    // <XIcon />,
    <LinkedInIcon  />,
  ];
  return (
    <Box
      sx={{
        bgcolor: "#142057",
     display:"flex",
     justifyContent:"center",
     padding:0
      }}
    >
      <Container  fixed sx={{ height: "100%", width: "82%",margin:0,marginBottom:"50px" , padding:0 ,marginTop:"100px"}}>
        <Grid container justifyContent={"center"}  >
          {/* About Section */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h3" className="walknow walknow-foot">
              {" "}
              {t("walknowlogo")}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Poppins-Regular",
                fontSize: "16px",

                color: "white",
              }}
            >
             {t("footerdescrip")} 
            </Typography>
            <br />
            {socialMediaIcons.map((socialMediaIcon,index) => {
              return (
                
                  <IconButton  onClick={()=>{
                    window.open("https://www.linkedin.com/in/sai-ram-68748a244","_blank")
                  }}  key={index}  sx={{ color: "white" }}>
                    {socialMediaIcon}
                  </IconButton>
                
              );
            })}
          </Grid>

          {/* Links Section */}
          <Grid item xs={12} sm={6} md={3}>
           
            <ol style={{ marginTop: "2px" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  pointerEvents: "none",
                }}
              >
                {quickLinks.map((quickLink ,index) => {
                  return (
                    
                      <Link
                      
                      key={index}
                        href={"/#"+quickLink.route}
                        underline="none"
                        sx={{
                          display: "inline-block",
                          color: "black",
                          mb: 1,
                          pointerEvents: "auto",
                        }}
                      >
                        <span
                          style={{
                            color: "white",

                            fontFamily: "Poppins-Regular",
                            fontSize: "18px",
                          }}
                        >
                          {quickLink.name}
                        </span>
                      </Link>
                    
                  );
                })}
              </Box>
            </ol>
          </Grid>

          {/* Contact Section */}
          <Grid item xs={12} sm={6} md={3}>
         
            <ol style={{ marginTop: "2px" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  pointerEvents: "none",
                }}
              >
                {websiteInfoLinks.map((websiteInfoLink,index) => {
                  return (
                    
                      <Link
                      key={index}
                        href={"/#"+websiteInfoLink.route}
                        
                        underline="none"
                        sx={{
                          display: "inline-block",
                          color: "black",
                          mb: 1,
                          pointerEvents: "auto",
                        }}
                      >
                        <span
                          style={{
                            color: "white",

                            fontFamily: "Poppins-Regular",
                            fontSize: "18px",
                          }}
                        >
                          {websiteInfoLink.name}
                        </span>
                      </Link>
                    
                  );
                })}
              </Box>
            </ol>
            
          </Grid>
          {/* Social Media Section */}
          {/* <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{ mb: 1, fontWeight: 600, color: "white", font: "poppnis" }}
            >
              Follow Us
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <IconButton sx={{ color: "white" }}>
                <InstagramIcon />
              </IconButton>
              <IconButton sx={{ color: "white" }}>
                <FacebookOutlinedIcon />
              </IconButton>
              <IconButton sx={{ color: "white" }}>
                <XIcon />
              </IconButton>
              <IconButton sx={{ color: "white" }}>
                <LinkedInIcon />
              </IconButton>
            </Box>
          </Grid> */}
        </Grid>

        {/* Footer Bottom */}
       
      </Container>
    </Box>
  );
};

export default Footer;
